import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderTop: `2px solid ${colors.gray.l90}`,
    marginBottom: '40px',
    paddingTop: '35px',
  },
  heading: {
    marginBottom: '8px',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    [theme.breakpoints.down(600)]: {
      fontSize: '20px',
      lineHeight: '28px',
    },
  },
  headingContainer: {
    marginRight: '0px',
    marginLeft: '0px',
    [theme.breakpoints.down(600)]: {
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  description: {
    marginBottom: '15px',
    fontSize: '16px',
    fontWeight: 400,
    [theme.breakpoints.down(600)]: {
      fontSize: '14px',
    },
  },
  scrollContainer: {
    width: '100%',
    [theme.breakpoints.down(1400)]: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'scroll',
      overflowY: 'hidden',
      scrollBehavior: 'smooth',
      WebkitOverflowScrolling: 'touch',
      paddingLeft: '24px',
      paddingRight: '24px',
      '&::-webkit-scrollbar': { display: 'none' },
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none',
      [theme.breakpoints.down(600)]: {
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      [theme.breakpoints.down(400)]: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
  },
  cardsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(23%, auto))',
    columnGap: '24px',
    paddingRight: '24px',
    [theme.breakpoints.down(1400)]: {
      display: 'flex',
      flexWrap: 'nowrap',
      gap: '24px',
      paddingRight: '24px',
      flexShrink: 0,
      minWidth: 'max-content',
      '& > *': {
        minWidth: '280px',
        maxWidth: '350px',
        flexShrink: 0,
      },
      [theme.breakpoints.down(600)]: {
        '& > *': {
          minWidth: '260px',
          maxWidth: '320px',
        },
      },
      [theme.breakpoints.down(480)]: {
        '& > *': {
          minWidth: '220px',
          maxWidth: '280px',
        },
      },
      [theme.breakpoints.down(400)]: {
        '& > *': {
          minWidth: '180px',
          maxWidth: '260px',
        },
      },
    },
  },
}));
